export default __webpack_public_path__ + "static/linkedin-1f14a8f960d96c63a195c8cfbe47c95d.png";